import React, { useState } from 'react';
import classname from 'classname';
import { CaretDownIcon } from 'components/icons';
import { AnimatePresence, motion } from 'framer-motion';
import { useHistory } from 'react-router';
import styles from './menuitem.module.scss';

export default function MenuItem({
  pathWithSlash,
  id,
  onClick,
  path,
  icon,
  name,
  subMenu,
  disabled,
  expandedId,
  setExpandedId,
  show,
  isExternal = false,
  pathname,
  ...rest
}) {
  const dropdown = id === expandedId;
  const history = useHistory();
  const handleMenuClick = () => {
    if (subMenu && subMenu.length > 0) {
      setExpandedId(expandedId === id ? null : id);
      return;
    }
    setExpandedId(null);
    onClick(path, isExternal);
  };

  const handleSubMenuClick = (e, subMenuPath) => {
    history.push(subMenuPath);
  };
  return (
    <>
      {show && (
        <>
          <button
            type="button"
            data-testId="menuitem"
            className={classname(
              styles.sidebaritem,
              path?.includes(pathWithSlash) ? styles.active : '',
            )}
            onClick={handleMenuClick}
            {...rest}
            disabled={disabled}
          >
            {icon}
            <p className={styles.sidebaritemtext}>{name}</p>
            {subMenu && !disabled && (
              <CaretDownIcon
                className={classname(styles.caret, dropdown ? styles.open : '')}
              />
            )}
          </button>
          <AnimatePresence initial={false}>
            {dropdown && (
              <motion.div
                key="content"
                className={styles.subitems}
                initial="collapsed"
                animate="open"
                exit="collapsed"
                variants={{
                  open: { opacity: 1, height: 'auto' },
                  collapsed: { opacity: 0, height: 0 },
                }}
                transition={{ ease: 'easeInOut', duration: 0.4 }}
              >
                {subMenu
                  ? subMenu.map((submenu) => (
                      <button
                        onClick={(e) => handleSubMenuClick(e, submenu.path)}
                        key={submenu.id}
                        type="button"
                        className={classname(
                          styles.subitem,
                          pathname === submenu.path ? styles.active : '',
                        )}
                      >
                        <span className={styles.circle} />
                        <p className={styles.text}>{submenu.name}</p>
                      </button>
                    ))
                  : null}
              </motion.div>
            )}
          </AnimatePresence>
        </>
      )}
    </>
  );
}
